export const joinString = (array: string[]) => {
  return array?.filter((x) => !!x)?.join(', ');
};

export function stringToColor(str: string) {
  const colors = [
    '#65a30d',
    '#db2777',
    '#c026d3',
    '#9333ea',
    '#7c3aed',
    '#4f46e5',
    '#2563eb',
    '#0284c7',
    '#059669',
  ];

  // Tạo hash nhanh
  let hash = 0;
  for (let i = 0, len = str?.length; i < len; i++) {
    hash = (hash << 5) - hash + str?.charCodeAt(i);
    hash |= 0; // Chuyển về số nguyên 32-bit
  }

  // Chọn màu nhanh
  const index = Math.abs(hash % colors?.length);
  return colors?.[index];
}

export const validateCookie = (token: string) => {
  return (
    typeof token === 'string' && token.trim() !== '' && token !== 'null' && token !== 'undefined'
  );
};

export function removeVietnameseTones(str: string) {
  return str
    .normalize('NFD') // tách ký tự và dấu
    .replace(/[\u0300-\u036f]/g, '') // xóa dấu
    .replace(/đ/g, 'd') // đ -> d
    .replace(/Đ/g, 'D') // Đ -> D
    .replace(/[^0-9a-zA-Z\s]/g, ' ') // bỏ ký tự đặc biệt giữ lại chữ & số
    .replace(/\s+/g, ' ') // gộp nhiều khoảng trắng
    .trim(); // xóa khoảng trắng đầu/cuối
}
